import privacyPolicy from '../content/legal/privacy-policy.txt?raw';
import termsGlobal from '../content/legal/terms-of-service.txt?raw';
import termsIndia from '../content/legal/terms-of-service-india.txt?raw';

export const LEGAL_DOCUMENTS = {
  privacy: privacyPolicy,
  termsGlobal,
  termsIndia,
} as const;
